module.exports = __webpack_public_path__ + "static/img/qq.24758d96.png";